import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Lock } from 'lucide-react';
export const ClassifiedProject = () => {
  return <section className="relative bg-base-black py-20 border-y border-dark-3 overflow-hidden" data-id="element-41">
      {/* Background grid + accent lines */}
      <div className="absolute inset-0 bg-tactical-grid opacity-[0.08] pointer-events-none" data-id="element-42"></div>
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-acid-green/40 to-transparent" data-id="element-43"></div>
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-acid-green/40 to-transparent" data-id="element-44"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-45">
        <div className="max-w-5xl mx-auto" data-id="element-46">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="border border-acid-green/30 bg-base-black relative overflow-hidden grid grid-cols-1 md:grid-cols-2" data-id="element-47">
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-5 h-5 border-t-2 border-l-2 border-acid-green/60 z-20 pointer-events-none" data-id="element-48"></div>
            <div className="absolute top-0 right-0 w-5 h-5 border-t-2 border-r-2 border-acid-green/60 z-20 pointer-events-none" data-id="element-49"></div>
            <div className="absolute bottom-0 left-0 w-5 h-5 border-b-2 border-l-2 border-acid-green/60 z-20 pointer-events-none" data-id="element-50"></div>
            <div className="absolute bottom-0 right-0 w-5 h-5 border-b-2 border-r-2 border-acid-green/60 z-20 pointer-events-none" data-id="element-51"></div>

            {/* Scanline accent on top */}
            <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-acid-green to-transparent z-20 pointer-events-none" data-id="element-52"></div>

            {/* LEFT: Text Content */}
            <div className="relative z-10 bg-dark-1 p-8 md:p-12 flex items-center order-2 md:order-1" data-id="element-53">
              <div data-id="element-54">
                <div className="flex items-center gap-4 mb-5" data-id="element-55">
                  <div className="shrink-0 w-12 h-12 rounded-full border border-acid-green/40 bg-acid-green/10 flex items-center justify-center text-acid-green relative" data-id="element-56">
                    <ShieldAlert size={22} data-id="element-57" />
                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-base-black rounded-full flex items-center justify-center" data-id="element-58">
                      <Lock size={9} className="text-text-dimmed" data-id="element-59" />
                    </div>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-60">
                    <span className="w-2 h-2 bg-acid-green animate-pulse" data-id="element-61"></span>
                    <span className="font-barlow font-bold text-[10px] text-acid-green tracking-[4px] uppercase" data-id="element-62">
                      CLASSIFIED INTEL — LEVEL 4
                    </span>
                  </div>
                </div>

                <h3 className="font-bebas text-3xl md:text-4xl text-white tracking-wide mb-4" data-id="element-63">
                  ACTIVE U.S. GOVERNMENT CONTRACT
                </h3>
                <p className="font-inter text-sm md:text-base text-text-body leading-relaxed mb-4" data-id="element-64">
                  We're currently building a second, restricted-issue mask —
                  engineered exclusively for U.S. government and military use
                  under an active federal contract. That unit will never be
                  available to the public.
                </p>
                <p className="font-inter text-sm md:text-base text-white leading-relaxed font-medium" data-id="element-65">
                  The mask you can buy today is our civilian flagship — the same
                  DNA, the same obsession, the same{' '}
                  <span className="text-acid-green" data-id="element-66">PATENT PENDING</span>{' '}
                  engineering.
                </p>

                {/* Patent Pending Badge */}
                <div className="mt-5 inline-flex items-center gap-2 border border-acid-green/40 bg-acid-green/5 px-3 py-1.5" data-id="element-67">
                  <span className="w-1 h-1 bg-acid-green animate-pulse" data-id="element-68"></span>
                  <span className="font-barlow font-bold text-[10px] text-acid-green tracking-[3px] uppercase" data-id="element-69">
                    U.S. PATENT PENDING
                  </span>
                </div>
              </div>
            </div>

            {/* RIGHT: Image Panel — Fully visible */}
            <div className="relative min-h-[320px] md:min-h-[480px] order-1 md:order-2 overflow-hidden" data-id="element-70">
              <img src="https://cdn.magicpatterns.com/uploads/1VfFbzeG6PLWskxprS5dbU/hf_20260519_142822_5efe37ff-2148-46ab-b7c6-85a4e80d80c1.png" alt="Classified Project — Operator with mask in tactical command center" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-71" />

              {/* "LIVE FEED" indicator overlay */}
              <div className="absolute top-4 right-4 z-10 flex items-center gap-2 bg-base-black/70 backdrop-blur-sm border border-acid-green/30 px-2.5 py-1" data-id="element-72">
                <span className="w-1.5 h-1.5 bg-acid-green animate-pulse rounded-full" data-id="element-73"></span>
                <span className="font-barlow font-bold text-[9px] text-acid-green tracking-[3px] uppercase" data-id="element-74">
                  LIVE FEED
                </span>
              </div>

              {/* Bottom location stamp */}
              <div className="absolute bottom-4 left-4 z-10 bg-base-black/70 backdrop-blur-sm border border-dark-3 px-2.5 py-1" data-id="element-75">
                <span className="font-barlow font-bold text-[9px] text-white/80 tracking-[2px] uppercase" data-id="element-76">
                  ● TACTICAL OPS · CLASSIFIED LOCATION
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};